import React from 'react'

import { Field, useFormikContext } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Col } from '_zari/core'

import * as RequerimientoService from 'services/requerimiento.service'

const OficinaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const __zariContext = React.useContext(ZariContext)
  const { values, setFieldValue } = useFormikContext()
  const [areas, setAreas] = React.useState([])

  React.useEffect(() => {
    RequerimientoService.obtenerOficinasDelUsuario()
      .then(({ data }) => {
        setAreas(data)
        if (!values._idOficinaSolicitante && data.length > 0) {
          setFieldValue('_idOficinaSolicitante', data[0]._id)
        }
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Form.Group>
      <Form.Label text='OFICINA SOLICITANTE' htmlFor='select-oficinasolicitante' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='_idOficinaSolicitante'>
          {({ field }) => (
            <Form.Select
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-oficinasolicitante'
            >
              <option value=''>Seleccionar</option>
              {areas.map((val, key) => (
                <option key={key} value={val._id}>
                  {val.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(OficinaFormGroup)
